import { Button, Checkbox, FormControlLabel, Grid, Icon } from '@mui/material'
import React, { FC } from 'react'
import { VehicleAdditionalCharge } from '../../../../../api/vehicle/taxisAPI.types'
import Input from '../../../../FormFields/Input/Input'
import { getAdornmentProps } from './CreateAdditionalCharge'

interface ViewAdditionalChargeProps {
  additionalCharge: VehicleAdditionalCharge
  chargeExceptions: any[] | undefined
  isEdit: boolean
  index: number
  additionalCharges: VehicleAdditionalCharge[]
  setAdditionalCharges: any
}
const ViewAdditionalCharge: FC<ViewAdditionalChargeProps> = (props) => {
  const {
    additionalCharge,
    chargeExceptions,
    isEdit,
    index,
    additionalCharges,
    setAdditionalCharges,
  } = props

  const getChargeExceptionById = (additionalChargeId: number) => {
    const found = chargeExceptions?.find(
      (charge) => charge.id === additionalChargeId,
    )
    return found?.name
  }

  return (
    <>
      <Grid item xs={5}>
        <Input
          label="Congestion zone"
          value={getChargeExceptionById(additionalCharge.additionalChargeId)}
          disabled={true}
        />
      </Grid>
      <Grid item xs={5}>
        <Input
          label="Fee type"
          value={additionalCharge.chargeTypeName}
          disabled={true}
        />
      </Grid>
      <Grid item xs={5}>
        <Input
          label="Value"
          value={additionalCharge.value}
          InputProps={getAdornmentProps(additionalCharge.chargeTypeName)}
          disabled={true}
        />
      </Grid>
      <Grid item xs={5}>
        <Input
          label="VAT"
          //@ts-ignore
          value={additionalCharge.vatTypeName}
          disabled={true}
        />
      </Grid>
      <Grid item xs={5}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={additionalCharge.applyMarkup}
              disabled={true}
            />
          }
          label="Apply markup"
        />
      </Grid>
      {isEdit && (
        <Button
          variant="contained"
          endIcon={<Icon>remove</Icon>}
          onClick={() => {
            const newArray = additionalCharges.filter(
              (value: any, i: number) => i !== index,
            )
            setAdditionalCharges(newArray)
          }}
        >
          Remove additional charge
        </Button>
      )}
    </>
  )
}

export default ViewAdditionalCharge
